module.exports = __webpack_public_path__ + "static/media/error-icon.3952b5c1.svg";